export default __webpack_public_path__ + "static/media/our-services-edu-secondary.988aab70.jpg";